import { Action } from "../../index";
import { connect, Dispatch } from "react-redux";

import API from "../../../vendor/api";
import { normalize } from "normalizr";
import * as schema from "../../schema";

import { addContactEntity, addContactEntities } from "../contacts/contacts";
import { addUserEntity, addUserEntities} from "../users/users";

/**
 * Actions
 */

// Fetch contacts

export const INVITE_PATIENT_REQUEST = "zig/appContacts/INVITE_PATIENT_REQUEST";
function invitePatientRequest() {
    return {
        type: INVITE_PATIENT_REQUEST
    };
}

export const INVITE_PATIENT_SUCCESS = "zig/appContacts/INVITE_PATIENT_SUCCESS";
function invitePatientSuccess(json: any) {
    return {
        type: INVITE_PATIENT_SUCCESS,
        payload: {
            json
        }
    };
}

export function invitePatient(phone: string) {
    return function (dispatch: Dispatch<any>) {
        dispatch(invitePatientRequest());

        API.invitePatient(phone).then(res => {
            dispatch(invitePatientSuccess(res));
        }).catch(err => {
            console.error(err);
            // dispatch(invitePatientFailure(err));
        });
    };
}

export function inviteDoctor(phone: string) {
    return function (dispatch: Dispatch<any>) {
        //dispatch(invitePatientRequest());

        API.inviteDoctor(phone).then(res => {
            //dispatch(invitePatientSuccess(res));
        }).catch(err => {
            console.error(err);
            // dispatch(invitePatientFailure(err));
        });
    };
}


// export function createGroup() {
//     return function (dispatch: Dispatch<any>) {
//         dispatch(invitePatientRequest());

//         API.crea(phone).then(res => {
//             dispatch(invitePatientSuccess(res));
//         }).catch(err => {
//             console.error(err);
//             // dispatch(invitePatientFailure(err));
//         });
//     };
// }

export const FETCH_CONTACTS_REQUEST = "meumedico/appContacts/FETCH_CONTACTS_REQUEST";
export function fetchContactsRequest() {
    return {
        type: FETCH_CONTACTS_REQUEST
    };
}

export const FETCH_CONTACTS_SUCCESS = "meumedico/appContacts/FETCH_CONTACTS_SUCCESS";
export function fetchContactsSuccess() {
    return {
        type: FETCH_CONTACTS_SUCCESS
    };
}

export const FETCH_CONTACTS_FAILURE = "meumedico/appContacts/FETCH_CONTACTS_FAILURE";
export function fetchContactsFailure() {
    return {
        type: FETCH_CONTACTS_FAILURE
    };
}

/**
 * Async Functions
 */

export function fetchContacts() {
    return (dispatch: Dispatch<any>) => {
        dispatch(fetchContactsRequest());

        API.getAllMyContacts().then(contacts => {
            const normalizr = normalize(contacts, schema.users);
            // console.log(normalizr);

            dispatch(addUserEntities(normalizr.entities.user));
            dispatch(addContactEntities(normalizr.result));

            dispatch(fetchContactsSuccess());
        }).catch(e => fetchContactsFailure());
    };
}

/**
 * Reducer
 */

export interface AppContactsState {
    invitePatientDialogOpen: boolean;
}

const AppContactsStateDefault: AppContactsState = {
    invitePatientDialogOpen: false
};

export default function reducer(state: AppContactsState = AppContactsStateDefault, action: Action<any>) {
    switch (action.type) {
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/appContacts/appContacts.ts